import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { Voter } from 'src/app/models/Voter';
import { Store } from '@ngrx/store';
import * as xlsx from 'xlsx';
import { Common } from 'src/app/shared/common';
import { setNewFileAction, setVotersAction, setVotersImportDateAction } from 'src/app/states/creationActions';

@Component({
  selector: 'app-poll-creation-import',
  templateUrl: 'poll-creation-import.component.html',
  styleUrls: ['./poll-creation-import.component.less', '../../../shared/common.less'],
})

export class PollCreationImportComponent implements OnInit {
  private _voters: Array<Voter> = [];

  @Input()
  get voters(): Array<Voter> { return this._voters; }
  set voters(value: Array<Voter>) {
    this._voters = value;
    this.filteredVoters = [...value];
    this.checkIfListReady()
  }

  @Input() hasSecurityQuestion = false;
  @Input() isSMS = false;
  @Input() is2FA = false;
  @Input() canChangePhone = false;
  @Input() votersConfirmed = false;
  @Output() votersChange = new EventEmitter<Array<Voter>>();
  @Output() confirmVoters = new EventEmitter<boolean>();
  invalidVoters: Array<Voter> = [];
  file: any;
  arrayBuffer: any;
  worksheet: any;
  excelVoters: Array<Voter> = [];
  selectedVoters: Array<Voter> = [];
  filteredVoters: Array<Voter> = [];
  isVotersValid = false;
  editingIndex: number = -1;
  editingVoter: Partial<Voter> = {};
  votersCount = 0;
  votersCountString = '0';
  isListReady = false;
  readonly = false;
  deleteVoterPopup = false;
  addVoterPopup = false;
  activeCollegeFilter: string = 'Tous';
  validateListPopup = false;
  phoneErrorMessage = '';
  codeErrorMessage = '';

  constructor(
    public common: Common,
    private store: Store
  ) { }

  onPartialChange() {
  }

  onlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    }
    return true;
  }

  checkIfListReady() {
    if (this.voters.length === 0) {
      this.isListReady = false;
      return;
    }

    const allHaveEmail = this.voters.every(v => this.common.validateEmail(v.email));
    const allHaveCollege = this.voters.every(v => v.college != null && String(v.college).trim().length > 0);
    const allHavePhone = this.voters.every(v => v.phone != null && this.common.isPhoneValid(v.phone));
    const allHaveValidationCode = this.voters.every(v => v.validationCode != null && v.validationCode.length > 0);
    if ((this.is2FA && !allHavePhone) && !this.canChangePhone) {
      this.phoneErrorMessage = '- Certains électeurs n\'ont pas de numéro de téléphone valide.';
    } else this.phoneErrorMessage = ''
    if (this.hasSecurityQuestion && !allHaveValidationCode) {
      this.codeErrorMessage = '- Certains électeurs n\'ont pas de code de validation valide.';
    } else this.codeErrorMessage = ''

      this.isListReady =
        allHaveEmail &&
        allHaveCollege &&
        (!this.isSMS || allHavePhone || this.canChangePhone) &&
        (!this.is2FA || allHavePhone || this.canChangePhone) &&
        (!this.hasSecurityQuestion || allHaveValidationCode);
  }

  trackByIndex(index: number): number {
    return index;
  }

  onSearch(value: string) {
    const query = value.trim().toLowerCase();
    if (!query) {
      this.filteredVoters = [...this.voters];
    } else {
      this.filteredVoters = this.voters.filter(v =>
        v.firstName?.toLowerCase().includes(query) ||
        v.lastName?.toLowerCase().includes(query)
      );
    }
  }

  displayValidateListPopup() {
    this.validateListPopup = true;
  }

  validateList($event: boolean) {
    this.validateListPopup = false;
    this.votersConfirmed = $event;
    if ($event) {
      this.confirmVoters.emit(true);
    }
  }

  getCollegeVoters(college: string) {
    this.activeCollegeFilter = college;
    if (college === 'Tous') {
      return this.filteredVoters = [...this.voters];
    }
    return this.filteredVoters = this.voters.filter(v => v.college != null ? String(v.college).trim() === college : false);
  }

  displayDeleteVoterPopup() {
    this.deleteVoterPopup = true;
  }

  deleteSelected($event: boolean) {
    this.deleteVoterPopup = false;
    if ($event) {
      this.voters = this.voters.filter(v => !this.selectedVoters.includes(v));
      this.filteredVoters = [...this.voters];
      if (this.voters.length === 0) {
        this.isVotersValid = false;
      }
      this.selectedVoters = [];
      this.votersChange.emit(this.voters);
    }
  }

  addVoter() {
    this.addVoterPopup = true;
  }

  closeAddVoterPopup() {
    this.addVoterPopup = false;
  }

  addSelected($event) {
    this.addVoterPopup = false;
    this.voters = [...this.voters, $event];
    //this.voters.push($event);
    this.filteredVoters = [...this.voters];
    this.votersChange.emit(this.voters);
  }

  get getColleges(): Array<string> {
    return this.voters.map(v => v.college != null ? String(v.college).trim() : null).filter((value, index, self) => value && self.indexOf(value) === index);
  }

  getCollegeCount(name: string): number {
    return this.voters.filter(v => v.college != null ? String(v.college).trim() === name : false).length;
  }

  startEdit(index: number) {
    this.editingIndex = index;
    this.editingVoter = { ...this.voters[index] };
  }

  cancelEdit() {
    this.editingIndex = -1;
    this.editingVoter = {};
  }

  validateEdit(index: number) {
    Object.assign(this.voters[index], this.editingVoter);
    this.editingIndex = -1;
    this.editingVoter = {};
  }

  editLastNameAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, lastName: value };
  }

  editFirstNameAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, firstName: value };
  }

  editCollegeAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, college: value };
  }

  editEmailAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, email: value };
  }

  editPhoneAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, phone: value };
  }

  editValidationCodeAtIndex(index: number, value: string) {
    this.editingVoter = { ...this.editingVoter, validationCode: value };
  }

  onVoterEdited() {
    this.voters = [...this.voters]; // nouvelle référence → déclenche le setter
    this.votersChange.emit(this.voters);
  }

  resetVoters() {
    this.voters = [];
    this.filteredVoters = [];
  }

  onFileChanged(event: { target: { files: any[] } }) {

    this.resetVoters();
    this.invalidVoters = [];
    if (event.target.files && event.target.files[0]) {
      this.file = event.target.files[0];
      this.fileReader(this.file, Voter);
    }
    this.store.dispatch(setNewFileAction({ fileChanged: true }));
    this.store.dispatch(setVotersImportDateAction({ voterImportDate: new Date().toLocaleString() }));
  }

  onFileDropped(event: any[]) {
    this.invalidVoters = [];
    if (event && event[0]) {
      this.file = event[0];
      this.fileReader(this.file, Voter);
    }
    this.store.dispatch(setNewFileAction({ fileChanged: true }));
    this.store.dispatch(setVotersImportDateAction({ voterImportDate: new Date().toLocaleString() }));
  }

  private fileReader(file: any, line: any) {
    const fileReader = new FileReader();
    fileReader.onload = (_e) => {
      this.arrayBuffer = fileReader.result;
      const data = new Uint8Array(this.arrayBuffer);
      const arr = [];
      for (let i = 0; i !== data.length; i++) {
        arr[i] = String.fromCharCode(data[i]);
      }
      const bstr = arr.join('');
      const workbook = xlsx.read(bstr, { type: 'binary', cellDates: true });
      const firstSheetName = workbook.SheetNames[0];

      const worksheet = workbook.Sheets[firstSheetName];
      this.worksheet = xlsx.utils.sheet_to_json(worksheet, { raw: true });
      this.matchingCell(this.worksheet, line);
    };
    fileReader.readAsArrayBuffer(file);
  }

  private matchingCell(worksheet: any, _line: any) {
    const dictionaryLine = worksheet[0];
    const voterKey = Object.keys(dictionaryLine)[0];
    const collegeKey = Object.keys(dictionaryLine)[1];
    const phoneKey = Object.keys(dictionaryLine)[2];
    const firstNameKey = Object.keys(dictionaryLine)[3];
    const lastNameKey = Object.keys(dictionaryLine)[4];
    const languageKey = Object.keys(dictionaryLine)[5];
    const validationKey = Object.keys(dictionaryLine)[6];
    if (validationKey == undefined) {
      // this.isOutdatedFile.emit(true);
    } else {
      let hasErrorLines = false;
      this.voters = [];
      for (let i = 1; i < worksheet.length; i++) {
        const worksheetLine = worksheet[i];
        if (voterKey !== undefined) {
          if (worksheetLine[voterKey] == undefined) {
            this.invalidVoters.push(
              new Voter(null, null, i + 2 + '', null, null, null, null)
            );
            hasErrorLines = true;
          } else {
            const email = worksheetLine[voterKey].trim();
            const ponderation = '1';
            const phone = worksheetLine[phoneKey];
            if (phone !== undefined && typeof phone === 'string') {
              phone.trim();
            }
            const firstName = worksheetLine[firstNameKey];
            const lastName = worksheetLine[lastNameKey];
            const language = worksheetLine[languageKey] != null && worksheetLine[languageKey] != undefined && worksheetLine[languageKey].length > 1 ? worksheetLine[languageKey].toLowerCase() : this.common.getLangCode();
            let validationCode = null;
            if (validationKey !== undefined && dictionaryLine[validationKey].trim().length > 3) {
              validationCode = worksheetLine[validationKey] != null ? worksheetLine[validationKey].toString() : null;
            }
            const college = worksheetLine[collegeKey]
            const voter = new Voter(
              firstName,
              lastName,
              email,
              ponderation,
              phone,
              validationCode,
              language,
              college
            );
            this.voters.push(voter);
          }
        }
      }

      if (hasErrorLines) {
        this.resetVoters();
        this.excelVoters = [];
        this.voters = [];
        // this.sendVotersList.emit(ImportMessage.fromData(this.invalidVoters, ImportStatuses.errorEmail));
      } else {
        this.validateVoters();
        if (this.invalidVoters.length === 0) {
          // this.store.dispatch(setVotersAction({ voters: this.voters }));
          this.validatePonderations();
          if (this.hasSecurityQuestion) { this.validateSecQuestion(); }
          if ((this.isSMS || this.is2FA) && this.invalidVoters.length === 0) {
            this.validateSMS();
          }
        }
      }
    }
  }

  validateSMS() {
    let isValid = true;
    const checkbox = document.getElementById('change-phone-checkbox') as HTMLInputElement;
    const phoneChangeable = checkbox.checked;
    this.voters.forEach((element, index) => {
      isValid =
        ((element.phone !== undefined &&
          this.common.isPhoneValid(element.phone)) ||
          (element.phone === undefined && (phoneChangeable || !this.is2FA)) &&
          isValid);
      if ((element.phone !== undefined && !this.common.isPhoneValid(element.phone) || (element.phone === undefined && !phoneChangeable))) {
        this.invalidVoters.push((new Voter(element.firstName, element.lastName, index + 3 + '', element.weight, element.phone, null, element.language)));
      }
    });
    if (isValid) {
      this.setVotersOK();
    } else {
      this.isVotersValid = false;
      this.voters = [];
      this.store.dispatch(setVotersAction({ voters: [] }));
      // this.sendVotersList.emit(ImportMessage.fromData(this.invalidVoters, ImportStatuses.errorSms));
    }
  }

  validateSecQuestion() {
    const isValid = this.voters.filter(element => element.validationCode != null && element.validationCode.length > 3).length === this.voters.length || !this.hasSecurityQuestion;
    if (isValid) {
      this.setVotersOK();
    } else {
      this.invalidVoters = this.voters.filter(element => element.validationCode == null || element.validationCode.length < 4);
      // this.sendVotersList.emit(ImportMessage.fromData(this.invalidVoters, ImportStatuses.errorPass));
    }
  }

  validatePonderations() {
    let isValid = true;
    this.invalidVoters = [];
    this.voters.forEach((element, index) => {
      isValid = Number.isInteger(Number(element.weight)) && isValid;
      if (
        !Number.isInteger(element.weight) ||
        Math.sign(parseInt(element.weight, 10)) !== 1
      ) {
        const newElement = structuredClone(element);
        newElement.email = (index + 3).toString();
        this.invalidVoters.push(newElement);
      }
    });
    if (isValid) {
      this.setVotersOK();
    } else {
      this.isVotersValid = false;
      this.resetVoters();
      this.voters = [];
      this.excelVoters = [];
      // this.sendVotersList.emit(ImportMessage.fromData(this.invalidVoters, ImportStatuses.errorWeights));
    }
  }

  validateVoters() {
    let isValid = true;
    this.invalidVoters = [];
    this.voters.forEach((element, index) => {
      isValid = this.common.validateEmail(element.email) && isValid;
      if (!this.common.validateEmail(element.email)) {
        this.invalidVoters.push((new Voter(element.firstName, element.lastName, index + 3 + '', element.weight, element.phone, null, 'fr')));
      }
    });
    if (isValid) {
      this.setVotersOK();
    } else {
      this.voters = [];
      this.isVotersValid = false;
      // this.sendVotersList.emit(ImportMessage.fromData(this.invalidVoters, ImportStatuses.errorEmail));
    }
  }

  setVotersOK() {
    this.isVotersValid = this.voters.length >= 1;
    this.votersCount = this.voters.length;
    this.votersCountString = this.votersCount.toLocaleString('fr-FR', {
      maximumFractionDigits: 2,
    });
    this.invalidVoters = [];
    this.excelVoters = this.voters;
    this.filteredVoters = [...this.voters];
    this.votersChange.emit(this.voters);
  }

  ngOnInit(): void {
  }
}
